<template>
    <div class="container-fluid">
        <div class="row">
          <div class="col text-start">
            <vue-excel-xlsx class="btn btn-outline-secondary btn-sm mb-2" v-if="datalists!==null" title="Download to Excel File"
              :data="datalists"
              :columns="columns"
              :filename="'report_summary'"
              :sheetname="'sheetname'"
              >
              Download
            </vue-excel-xlsx>
          </div>
        </div>
        <div class="row">
            <div class="col-sm bg-light border py-2">
                <table id="myRepTable" class="table table-striped table-hover table-bordered table-sm" style="width: 100%;">
                    <thead class="text-dark" style="background:NavajoWhite">
                    <tr>
                        <th style="width:50px;">เดือนที่</th>
                        <th style="width:150px;">รหัสชุดตรวจ</th>
                        <th style="width:300px;">ชุดตรวจ</th>
                        <th style="width:80px;">จำนวนเงิน</th>
                        <th style="width:100px;">จำนวนรายการ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!-- <tr v-for="item in datalists" :key="item.itemtestid" v-bind:data-id="item.ItemTestID"  @click="tableChanged(item)"> -->
                    <tr v-for="(item,index) in datalists" :key="index">
                        <td class="text-center">{{ item.MonthNo }}</td>
                        <td class="text-start">{{ item.TestCode }}</td>
                        <td class="text-start">{{item.TestName}}</td>
                        <td class="text-end">{{ numeralFormat(item.SumAmt, '0,0[.]00') }}</td>
                        <td class="text-center">{{ item.CountTimes }}</td>
                    </tr>
                    </tbody>
                </table>
                <br>
                <table id="myRepTable" class="table table-striped table-hover table-bordered table-sm" style="width: 100%;">
                  <tbody>
                    <tr>
                      <td style="text-align: center; width:500px;">รวม {{CountItems}} รายการ</td>
                      <td style="text-align: right;  width:80px;" >{{numeralFormat(TotalAmount, '0,0[.]00')}}</td>
                      <td style="text-align: right;  width:116px;" ></td>
                    </tr>
                  </tbody>
                </table>

            </div>
        </div>
    </div>

    <!-- PRINT PDF -->
    <div id="divToPrint" hidden>
        <table id="myRepLabStatusTable" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}" style="width: 100%;">
            <thead class="text-dark" >
            <tr>
                <th>รหัสชุดตรวจ</th>
                <th style="width:320px;">ชุดตรวจ</th>
                <th>เดือนที่</th>
                <th>จำนวนเงิน</th>
                <th>จำนวนรายการ</th>
            </tr>
            </thead>
            <tbody>
            <!-- <tr v-for="item in datalists" :key="item.itemtestid" v-bind:data-id="item.ItemTestID"  @click="tableChanged(item)"> -->
            <tr v-for="item in datalists" :key="item.ROID">
                <td class="text-center">{{ item.TestCode }}</td>
                <td class="text-start">{{item.TestName}}</td>
                <td class="text-center">{{ item.MonthNo }}</td>
                <td class="text-end">{{numeralFormat( item.SumAmt, '0,0[.]00') }}</td>
                <td class="text-center">{{ item.CountTimes }}</td>
            </tr>
            </tbody>
        </table>
    </div>

    <!-- PRINT PDF : TEST > MONTH_NO -->
    <!-- <div id="divToPrint2" ref="divToPrint2" hidden>
        <table id="myRepLabStatusTable" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}" style="width: 100%;">
            <thead class="text-dark" >
            <tr>
                <th>รหัสชุดตรวจ</th>
                <th style="width:320px;">ชุดตรวจ</th>
                <th>เดือนที่</th>
                <th>จำนวนเงิน</th>
                <th>จำนวนรายการ</th>
            </tr>
            </thead>
            <tbody>
                <template v-for="item1 in filterGroupTest(datalists)" :key="item1.TestCode">
                    <tr class="text-start" v-for="(item2, index2) in filterItemsOfGroup(datalists,item1.TestCode)" :key="item2.MonthNo">
                        <td><span v-if="index2==0"><b> {{ item2.TestCode }}</b></span></td>
                        <td><span v-if="index2==0"><b> {{item2.TestName}}</b></span></td>
                        <td style="text-align: center;">{{ item2.MonthNo }}</td>
                        <td style="text-align: right;">{{numeralFormat(item2.SumAmt, '0,0[.]00')}}</td>
                        <td style="text-align: center;">{{ item2.CountTimes }}</td>
                    </tr>
                </template>
                <tr>
                    <td style="text-align: center;" colspan="3" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">รวม {{CountItems}} รายการ</td>
                    <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">{{numeralFormat(TotalAmount, '0,0[.]00')}}</td>
                    <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}"></td>
                </tr>
            </tbody>
        </table>
    </div> -->

    <!-- PRINT PDF : MONTH_NO > TEST-->
    <div id="divToPrint2" ref="divToPrint2" hidden>
        <table id="myRepLabStatusTable" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}" style="width: 100%;">
            <thead class="text-dark" >
            <tr>
                <th >รหัสชุดตรวจ</th>
                <th >ชุดตรวจ</th>
                <th>เดือนที่</th>
                <th>จำนวนเงิน</th>
                <th>จำนวนรายการ</th>
            </tr>
            </thead>
            <tbody>
                <template v-for="item1 in filterDistinctMonthNo(datalists)" :key="item1">
                    <tr class="text-start" v-for="(item2, index2) in filterItemsOfMonth(datalists, item1.MonthNo)" :key="index2">
                        <td><span>{{index2 + 1}}. &nbsp; <b>{{item2.TestCode}}</b></span></td>
                        <td><span><b> {{item2.TestName}}</b></span></td>
                        <td style="text-align: center;">{{ item2.MonthNo }}</td>
                        <td style="text-align: right;">{{numeralFormat(item2.SumAmt, '0,0[.]00')}}</td>
                        <td style="text-align: center;">{{ item2.CountTimes }}</td>
                    </tr>
                    <!-- สรุปยอดรวมของแต่ละเดือน -->
                    <tr>
                        <td style="text-align: right;" colspan="3" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">ยอดรวมเป็นเงิน </td>
                        <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">{{numeralFormat(item1.SumTotalAmt, '0,0[.]00')}}</td>
                        <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}"></td>
                    </tr>
                    <tr>
                        <td style="text-align: right;" colspan="3" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">หัก ยอดรวมส่วนลด </td>
                        <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">{{numeralFormat(item1.SumDiscAmt, '0,0[.]00')}}</td>
                        <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}"></td>
                    </tr>
                    <tr>
                        <td style="text-align: right;" colspan="3" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">บวก ยอดรวมภาษีมูลค่าเพิ่ม </td>
                        <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">{{numeralFormat(item1.SumVatAmt, '0,0[.]00')}}</td>
                        <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}"></td>
                    </tr>
                    <tr>
                        <td style="text-align: right;" colspan="3" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">ยอดรวมสุทธิ </td>
                        <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}">{{numeralFormat(item1.SumNetAmt, '0,0[.]00')}}</td>
                        <td style="text-align: right;" data-pdfmake="{&quot;fillColor&quot;: &quot;#eeeeee&quot;}"></td>
                    </tr>
                    <tr>
                      <td style="text-align: right;" colspan="5">&nbsp;</td>
                    </tr>
                    <!-- ---------------------- -->
                </template>
            </tbody>
        </table>
    </div>

</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'jquery/dist/jquery.min.js'
// Datatable Modules
// import 'datatables.net-dt/js/dataTables.dataTables'
// import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'

import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'RepLabStatus',
  components: {

  },
  data () {
    return {
      columns: [
        { label: 'รหัสชุดตรวจ', field: 'TestCode' },
        { label: 'ชื่อชุดตรวจ', field: 'TestName' },
        { label: 'เดือนที่', field: 'MonthNo' },
        { label: 'จำนวนเงิน', field: 'SumAmt' },
        { label: 'จำนวนรายการ', field: 'CountTimes' }
      ],
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],

      // ชื่อชุดตรวจ สำหรับเป็น Group Name ไม่ซ้ำรายการ
      dataGroupTest: []
    }
  },
  props: ['datalists', 'branchSelected', 'dateFm', 'dateTo', 'statusSelectedText'],
  created () {

  },
  mounted () {
    if (this.datalists !== null) {
      this.createA4PdfReportToScreen()
    }
  },
  computed: {
    CountItems: function () {
      if (this.datalists == null) {
        return 0
      }
      return this.datalists.length
    },
    TotalAmount: function () {
      if (this.datalists !== null) {
        var TotalAmt = this.datalists.reduce(function (Total, data) {
          if (isNaN(data.SumAmt)) {
            data.SumAmt = 0
          }
          return Total + parseFloat(data.SumAmt)
        }, 0)

        return TotalAmt
      } else {
        return 0
      }
    }
  },
  methods: {
    // ----------- (1) รูปแบบใบแสดงผลเป็นฟอร์ม A4 (General) ---------- //
    createA4PdfReportToScreen () {
      const textBranch = this.branchSelected.BranchName
      const textDateFm = this.dateFm.toISOString().substr(0, 10)
      const textDateTo = this.dateTo.toISOString().substr(0, 10)
      // ==================================== //
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint2')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [30, 120, 30, 50],
        header: {
          columns:
          [
            { },
            {
              text: 'รายงานสรุปยอดขายเทส รายเดือน\n' + self.globalCorpInfo.name + '\nสาขา' + textBranch +
                    '\nสถานะเอกสาร : ' + this.statusSelectedText +
                    '\nระหว่างวันที่ ' + textDateFm + ' - ' + textDateTo,
              width: 376,
              alignment: 'center',
              lineHeight: 0.8,
              margin: [0, 20, 0, 0]
            },
            { }
          ]
        },
        footer: function (currentPage, pageCount) {
          const d = new Date()
          const textDate = d.toISOString().substr(0, 19).replace('T', ' ')
          return {
            margin: [40, 10, 40, 20],
            table: {
              widths: [200, 150, 150],
              body: [
                [
                  {
                    text: 'Printed date : ' + textDate,
                    border: [0, 0, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 0, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        // content: 'TEST *******************',
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 15,
          lineHeight: 0.7
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    // เดือนทั้งหมดในช่วงข้อมูล
    filterDistinctMonthNo: function (items) {
      if (items === null) {
        return []
      }
      const result = []
      const map = new Map()
      for (const item of items) {
        if (!map.has(item.MonthNo)) {
          map.set(item.MonthNo, true) // set any value to Map
          result.push(item) // เก็บค่าทั้ง Row
        }
      }
      return result
    },
    // A5reportDtl filter เฉพาะเทสของเดือน paraMonthNo
    filterItemsOfMonth: function (items, paraMonthNo) {
      if (items === null) {
        return []
      }
      const result = []
      for (const item of items) {
        // result.push(item)
        if (item.MonthNo === paraMonthNo) {
          result.push(item)
        }
      }
      return result
    },

    //
    filterGroupTest: function (items) {
      if (items === null) {
        return []
      }
      const result = []
      const map = new Map()
      for (const item of items) {
        if (!map.has(item.TestCode)) {
          map.set(item.TestCode, true) // set any value to Map
          result.push(item)
        }
      }
      return result
    },
    // A5reportDtl filter เฉพาะเทสที่อยู่ในชุดตรวจที่ส่งค่ามา paraTestID
    filterItemsOfGroup: function (items, paraTestCode) {
      if (items === null) {
        return []
      }
      const result = []
      for (const item of items) {
        // result.push(item)
        if (item.TestCode === paraTestCode) {
          result.push(item)
        }
      }
      return result
    }
  }
}
</script>

<style>

</style>
